import { fetchEntities, fetchPrompts } from 'actions';
import EntityList from 'components/EntityList';
import { RouteSpec, SuperRouteSpec } from 'types';

const entitiesRoutes: (RouteSpec | SuperRouteSpec)[] = [
  {
    name: 'entities',
    path: '/:customerDomain/entities',
    component: EntityList,
    private: true,
    permissions: 'entities.list',
    data: {
      actions: [fetchEntities, fetchPrompts],
      params: {
        order_desc: {
          defaultValue: 'true',
        },
        include_pii: {
          defaultValue: 'true',
        },
        include_count: {
          defaultValue: '1',
        },
        entities: {
          nestedResource: true,
          params: {
            limit: {
              defaultValue: '25',
            },
            offset: {
              defaultValue: '0',
            },
            is_starred: {},
            broad_search: {},
            name: {},
            order_by: {},
            order_desc: {},
            prompt_uuid: {},
            team_uuids: { list: true },
          },
        },
      },
    },
  },
];

export default entitiesRoutes;
